





import Vue from 'vue';

import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';

am4core.useTheme(am4themes_animated);

let chartInst: am4charts.XYChart;
const baseColor = am4core.color('rgb(0, 174, 239)');

export default Vue.extend({
  name: 'ChartSurface',
  props: {
    title: String,
    chartData: Array,
  },

  mounted() {
    const chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart);

    // chart.paddingBottom = 20;

    const categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = 'Device';
    categoryAxis.renderer.minGridDistance = 30;
    categoryAxis.renderer.labels.template.fontSize = 12;
    categoryAxis.renderer.labels.template.textAlign = 'middle';
    categoryAxis.renderer.labels.template.maxWidth = 80;
    categoryAxis.renderer.labels.template.wrap = true;
    categoryAxis.renderer.labels.template.rotation = 270;
    categoryAxis.renderer.labels.template.verticalCenter = 'middle';

    const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    // valueAxis.title.text = 'Share, %';
    valueAxis.numberFormatter.numberFormat = '#.%';

    const series = chart.series.push(new am4charts.ColumnSeries());
    series.name = 'Surface devices';
    series.columns.template.fill = baseColor;
    series.columns.template.tooltipText = 'Category: {categoryX}\nValue: {valueY.value.formatNumber("#.0#%")}';
    series.dataFields.valueY = 'Share';
    series.dataFields.categoryX = 'Device';

    // chart.dataFields.value = 'Share';
    // chart.dataFields.name = 'Device';

    // /* Configure top-level series */
    // const level1 = chart.seriesTemplates.create('0');
    // level1.columns.template.tooltipText = '{name}: {values.value.value.formatNumber("#.0#%")}';

    // /* Add bullet labels */
    // const level1Bullet = level1.bullets.push(new am4charts.LabelBullet());
    // level1Bullet.locationY = 0.5;
    // level1Bullet.locationX = 0.5;
    // level1Bullet.label.text = '{name}';
    // level1Bullet.label.fill = am4core.color('#fff');

    chartInst = chart;

    this.setupChart();
  },

  watch: {
    chartData: (val: object[]) => {
      chartInst.data = val;
    },
  },

  methods: {
    setupChart() {
      chartInst.data = this.$props.chartData;
    },
  },

  beforeDestroy() {
    if (chartInst) {
      chartInst.dispose();
    }
  },
});
